module.exports = __webpack_public_path__ + "static/media/Asset.cb8cfc4b.png";